// // dependency on external js: flickity.pkgd.js

// import {
//   slider
//   // hoverNav,
//   // orientation // don't need this  don't think
// } from '../slider/index';

// console.log("info-man-lottie.js");

// import bodymovin from 'bodymovin';
import jquery from 'jquery';

import lottie from '../../../../template-parts/blocks/media-info-management-home/assets/js/lottie'; // this allows the bodymoving to work!?
// import bodymovin from 'lottie-web';

export function infomanLottie($block, isadmin) {

  var $ = $ || jquery; // added to see solve jquery issue


   console.log("infomanLottie", $block, isadmin);
   console.log("$", $);
   console.log("jqoery", jQuery);

  if (isadmin == true) {
    console.log("admin == true:", isadmin);
  } else {
    console.log("admin == false:", isadmin);
  };

  var container = $block[0];

  // SliderContainerEl = container.querySelector(".slider__container");

  console.log("container", container);

  var bodymovinPath = $block.find(".lottie-item").attr("data-lottie");

  console.log("bodymovin", bodymovin);

  console.log("bodymovinPath", bodymovinPath);
  console.log("document.getElementById('bm')", document.getElementById('bm'));

 
  var animation = bodymovin.loadAnimation({
    container: document.getElementById('bm'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    // path: 'data.json'
    path: bodymovinPath
  })

  console.log("animation DONE", animation);

} //export function slideshow($block){